import "magnific-popup";
import * as Cookies from "js-cookie";

const $doc = $(document);

// Size guide popup
$doc.on("click", ".link-popup", function(e) {
  e.preventDefault();

  $.magnificPopup.open({
    items: {
      src: $("#shopify-section-size-guide .popup--size-guide")
    },
    type: "inline",
    fixedBgPos: false,
    fixedContentPos: false
  });
});

// Back in stock popup
$doc.on("click", ".back-in-stock", function(e) {
  e.preventDefault();

  $.magnificPopup.open({
    items: {
      src: $("#popup-back-in-stock")
    },
    type: "inline",
    fixedBgPos: false,
    fixedContentPos: false
  });
});

// Newsletter popup
$doc.on("click", ".popup-subscribe .link-close", function(e) {
  e.preventDefault();

  $(".popup-subscribe").fadeOut();
  Cookies.set("subscribe-popup", "hidden");
});

// Show popup after Klaviyo form is loaded
window.addEventListener("klaviyoForms", function(e) {
  if (e.detail.type == "embedOpen") {
    if (Cookies.get("subscribe-popup") !== "hidden") {
      const $popup = $(".popup-subscribe");
      const popupDelay = parseInt($popup.data("delay") * 1000);

      setTimeout(() => {
        $(".popup-subscribe").fadeIn();
      }, popupDelay);
    }
  }
});
